// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__l47SU","front":"Card_front__YfKVq","back":"Card_back__5u37f"};